import { render, staticRenderFns } from "./reveal-icon.vue?vue&type=template&id=624ad8fa&scoped=true&"
import script from "./reveal-icon.vue?vue&type=script&lang=js&"
export * from "./reveal-icon.vue?vue&type=script&lang=js&"
import style0 from "./reveal-icon.vue?vue&type=style&index=0&id=624ad8fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ad8fa",
  null
  
)

export default component.exports